// Lib
import React, { Fragment, useCallback } from 'react';
import {
  TableCell,
  TableRow as MuiTableRow,
  Collapse,
  Table,
  TableBody,
} from '@mui/material';

// Components
import CollapsedTableRow from '../CollapsedTableRow';

// Styles
import { useStyles } from './TableRowStyles';

const TableRow = ({
  columns,
  useCellsReducers = () => ({ cells: {} }),
  item,
  styles,
  collapsibleTable = false,
  withChildren = false,
  onToggleChildren = () => {},
  style,
  itemHeight,
}) => {
  const { classes, cx } = useStyles({ withChildren });

  const onToggleHeight = useCallback(() => {
    onToggleChildren(item?.children?.length + 1 || 1);
  }, [item, onToggleChildren]);

  const { cells } = useCellsReducers({
    order: item,
    onToggleChildren: onToggleHeight,
    withChildren,
  });

  return (
    <Fragment key={item.id}>
      <MuiTableRow
        // eslint-disable-next-line react/forbid-component-props -- runtime geometry from react-window
        style={style}
        className={cx(styles?.row, classes.collapsedRow)}>
        {columns?.map((column) => (
          <TableCell key={`${item.id}-${column.id}`} className={styles?.cell}>
            {cells[column.id]}
          </TableCell>
        ))}
      </MuiTableRow>

      {collapsibleTable && (
        <MuiTableRow
          // eslint-disable-next-line react/forbid-component-props -- runtime geometry from react-window
          style={{
            ...style,
            top: style.top + itemHeight,
            height: withChildren ? style.height : 0,
          }}>
          <TableCell className={classes.nestedCell} colSpan={9}>
            <Collapse in={withChildren} timeout={100} unmountOnExit>
              <Table className={classes.collapsedTable}>
                <TableBody>
                  {item.children?.map((childOrder) => {
                    let mergedOrder = {
                      ...item,
                      ...childOrder,
                      status: childOrder.status || item.status,
                    };
                    delete mergedOrder.children;
                    // Need to delete this property in child of distro for proper
                    // address count calculation and displaying right order qty values
                    delete mergedOrder.addresses;

                    return (
                      <CollapsedTableRow
                        key={mergedOrder.id}
                        useCellsReducers={useCellsReducers}
                        mergedOrder={mergedOrder}
                        item={item}
                        columns={columns}
                        styles={styles}
                      />
                    );
                  })}
                </TableBody>
              </Table>
            </Collapse>
          </TableCell>
        </MuiTableRow>
      )}
    </Fragment>
  );
};

export default TableRow;
